import React, {
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
} from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';

const RichTextEditor = forwardRef(({ onChange, value }, ref) => {
  const editorRef = useRef(null);
  const quillRef = useRef(null);
  const isUpdatingRef = useRef(false);
 
  useEffect(() => {
    if (!editorRef.current || quillRef.current) return;

    const quill = new Quill(editorRef.current, {
      theme: 'snow',
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, false] }],
          ['bold', 'italic', 'underline', 'strike'],
          [{ list: 'ordered' }, { list: 'bullet' }],
          ['link'],['clean'],
        ],
      },
      placeholder: 'Write something...',
    });

    quill.on('text-change', () => {
      if (!isUpdatingRef.current) {
        const content = quill.root.innerHTML;
        if (onChange) {
          onChange(content);
        }
      }
    });

    quillRef.current = quill;

    if (value) {
      isUpdatingRef.current = true;
      quill.clipboard.dangerouslyPasteHTML(value);
      isUpdatingRef.current = false;
    }

    return () => {
      if (quillRef.current) {
        quillRef.current.off('text-change');
        quillRef.current = null;
      }
      if (editorRef.current) {
        editorRef.current.innerHTML = '';
      }
    };
  }, []);

  useEffect(() => {
    if (quillRef.current && value !== undefined) {
      const currentContent = quillRef.current.root.innerHTML;
      if (currentContent !== value) {
        isUpdatingRef.current = true;
        quillRef.current.clipboard.dangerouslyPasteHTML(value);
        isUpdatingRef.current = false;
      }
    }
  }, [value]);

  useImperativeHandle(ref, () => ({
    getContent: () => {
      return quillRef.current ? quillRef.current.root.innerHTML : '';
    },
    setContent: (content) => {
      console.log('Setting content:', content);
      if (quillRef.current) {
        isUpdatingRef.current = true;
        quillRef.current.clipboard.dangerouslyPasteHTML(content);
        isUpdatingRef.current = false;
      }
    },
  }));

  return (
    <div
      ref={editorRef}
      style={{ height: '200px', background: '#fff', width: '100%' }}
    />
  );
});

export default RichTextEditor;